module.exports = __webpack_public_path__ + "img/Vector.d21fdff.png";